import { computed } from '@vue/composition-api';
import { ProjectStore } from './project';

const AllPermissions = [
  'edit:issue',
  'create:comment',
  'create:issue',
  'integration',
  'view:docs',
  'view:issue',
  'edit:subtask',
  'edit:docs'
] as const;
export type Permission = (typeof AllPermissions)[number];

export const usePermission = (
  project: ProjectStore
) => {
  const role = computed(() => project.currentProject.value?.projectRole);

  const permissions = computed<readonly Permission[]>(() => {
    if (
      project.projectRoles.value.some((r: any) =>
        [
          'organizationOwner',
          'organizationAdmin',
          'projectOwner',
          'projectAdmin'
        ].includes(r.roleCode)
      )
    ) {
      return AllPermissions;
    }
    
    if (project.currentProject.value) {
      if (role.value === 'innerCollaborator') {
        return ['create:comment', 'create:issue', 'view:docs', 'view:issue', 'edit:subtask', 'edit:docs'];
      }
      return AllPermissions;
    }
    return [];
  });

  const hasPermission = (permission: Permission) => {
    return permissions.value.includes(permission);
  };

  const hasProjectPermission = (roles: string[], operate: 'some' | 'every') => {
    const projectRoles = project.projectRoles.value.map((r: any) => r.roleCode);
    if (operate === 'every') {
      return roles.every((r) => projectRoles.includes(r));
    }
    return roles.some((r) => projectRoles.includes(r));
  };

  return { permissions, hasPermission, hasProjectPermission };
};

export type PermissionStore = ReturnType<typeof usePermission>;
